import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SisWorkflowUsuarioClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/workflow-usuario');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  WorkflowFuncionario');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/workflow-usuario', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  WorkflowFuncionario');
    }
  }

  async store(data) {
    // console.log(data);
    try {
      const { data: response } = await this.api.post('/workflow-usuario', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as  WorkflowFuncionario');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/workflow-usuario/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a  WorkflowFuncionario');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/workflow-usuario', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a  WorkflowFuncionario');
    }
  }

  async destroy(body) {
    try {
      const { data: response } = await this.api.post('/workflow-usuario/delete/', body);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a  WorkflowFuncionario');
    }
  }
}
